<template>
  <div v-show="showDialog" class="pop-cover">
    <div class="dialog-wrap">
      <div class="btn-close" @click="handleClose" />
      <div class="dialog-banner">
        合作咨询
      </div>
      <div class="dialog-des">
        顺丰科技可以为每位有意向客户提供更多个性化的服务和解决方案，为了能更好的为您提供更贴心的服务，请填写您的信息，我们工作人员会尽快与您取得联系！您也可以拨打我们的咨询热线:400-602-1111, 我们客服人员会为您服务。
      </div>
      <iframe src="https://dppj.sf-express.com/index"
        width="1000px" class="iframe-concact" height="520px" frameborder="0"
        />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Concact',
  data () {
    return {
      showDialog: false
    }
  },
  methods: {
    handleClose () {
      this.showDialog = false
    },
    showDialogs() {
      this.showDialog = true
    }
  }
}
</script>
<style  lang="less" >
html,body{
  width: 100%;
  height: 100%;
}
.pop-cover{
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 700;
  background: rgba(0, 0, 0, 0.4);
  .dialog-wrap{
    width: 1032px;
    height: 760px;
    background: #FFFFFF;
    border-radius: 4px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .btn-close{
      width: 18px;
      height: 18px;
      background: url('~@/assets/images/dialog-close-btn.png') center center no-repeat;
      background-size: contain;
      position: absolute;
      right: 0;
      top: -30px;
      cursor: pointer;
    }
    .dialog-banner{
      width: 1032px;
      height: 120px;
      border-radius: 4px 4px 0 0;
      box-sizing: border-box;
      padding-top: 34px;
      padding-left: 88px;
      background: url('~@/assets/images/dialog-banner.jpg') center center no-repeat;
      background-size: cover;
      font-family: PingFangSC-Medium;
      font-size: 38px;
      color: #2E75D0;
      letter-spacing: 0;
      line-height: 52px;
    }
    .dialog-des{
      margin: 24px 88px;
      font-size: 12px;
      color: #666666;
      letter-spacing: 0;
      line-height: 20px;
    }
    .iframe-concact {
      margin-left: 16px;
      .page-home {
        height: 100%!important;
      }
    }
    .wrap-form{
      padding: 0 88px;
      background: #fff;
    }
    .btn-wrap{
      padding:0 88px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .el-button{
        width: 108px;
        height: 32px;
        background: #d41024;
        border-radius: 2px;
        line-height: 32px;
        padding:0;
        border: 0 none;
      }
    }
  }
}
</style>
<style lang="less" scoped>
v-deep {
  .el-input__inner {
    -webkit-appearance: none;
    background-color: #FFF;
    background-image: none;
    border: 1px solid #C9D1DA;
    border-radius: 2px;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 32px;
    line-height: 32px;
    outline: 0;
    padding: 0 12px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    width: 100%;
  }
  .el-cascader{
    width: 100%;
  }
  .el-textarea__inner{
    display: block;
    resize: vertical;
    line-height: 1.5;
    box-sizing: border-box;
    width: 100%;
    font-size: inherit;
    color: #606266;
    background-color: #FFF;
    background-image: none;
    border: 1px solid #C9D1DA;
    border-radius: 2px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  }
  .el-textarea {
    padding:5px 0;
    .el-input__count{
      line-height: 12px;
      top: 100%;
      bottom: auto;
    }
  }
  .el-row{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

</style>
